import { jsxs as v, jsx as h } from "react/jsx-runtime";
import { E as f, S as g } from "./icons.types-0722eef5.js";
function w({ title: i, titleId: o, size: c, width: r, height: s, extended: l = !1, ...n }) {
  const a = l ? f : g, t = c ? a[c] : r || a[l ? "s" : "l"], e = c ? a[c] : s || a[l ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: e,
      "aria-labelledby": o,
      ...n,
      children: [
        i ? /* @__PURE__ */ h("title", { id: o, children: i }) : null,
        /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            d: "M13.256 9.59h9.487c.284 0 .521.096.713.287.192.192.287.43.287.713 0 .284-.095.521-.287.712a.968.968 0 0 1-.713.288h-9.487a.968.968 0 0 1-.712-.288.969.969 0 0 1-.288-.713c0-.283.096-.52.288-.712a.968.968 0 0 1 .712-.287Zm0 3.846h9.487c.284 0 .521.096.713.287.192.192.287.43.287.713 0 .284-.095.521-.287.713a.968.968 0 0 1-.713.287h-9.487a.967.967 0 0 1-.712-.288.968.968 0 0 1-.288-.713c0-.283.096-.52.288-.712a.968.968 0 0 1 .712-.287ZM8 28.666c-.932 0-1.72-.322-2.366-.967-.645-.646-.968-1.434-.968-2.366v-2.64c0-.342.116-.629.347-.86.231-.23.517-.346.859-.346h2.794V5.744c0-.663.237-1.23.709-1.703a2.32 2.32 0 0 1 1.702-.708h13.846c.663 0 1.23.236 1.702.708a2.32 2.32 0 0 1 .708 1.703v7.871c0 .284-.096.521-.287.713a.969.969 0 0 1-.713.287.967.967 0 0 1-.713-.287.968.968 0 0 1-.287-.713V5.744a.4.4 0 0 0-.115-.295.4.4 0 0 0-.295-.116H11.077a.4.4 0 0 0-.295.116.4.4 0 0 0-.116.295v15.743h2.898c.283 0 .52.096.712.288.192.191.288.429.288.713 0 .283-.096.52-.288.712a.968.968 0 0 1-.712.287H6.666v1.846c0 .378.128.695.384.95.255.256.572.384.95.384h5.564c.283 0 .52.095.712.287.192.192.288.43.288.713s-.096.52-.288.712a.968.968 0 0 1-.712.287H8Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            d: "M26.764 19.743 21.8 24.708l-2.13-2.144a.944.944 0 0 0-.697-.277.944.944 0 0 0-.696.277.951.951 0 0 0-.294.706.944.944 0 0 0 .281.686l2.692 2.726c.241.24.523.361.844.361.321 0 .602-.12.843-.361l5.513-5.513a.947.947 0 0 0 .294-.703 1.012 1.012 0 0 0-.28-.702.955.955 0 0 0-.703-.314.947.947 0 0 0-.703.293Z"
          }
        )
      ]
    }
  );
}
export {
  w as FileCheck
};
